// use this when we want to submit the form on document load
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    refreshCSRFTokens();
    this.element.requestSubmit();
  }
}
